import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { createSlice } from '@reduxjs/toolkit';

interface ConopPhase1State {
  conopPhase1Data: {
    answer: string;
  } | null;
  isRegenerated?: boolean;
  title?: string;
}

const initialState: ConopPhase1State = {
  conopPhase1Data: null,
  title: undefined,
};

const { name, reducer, actions } = createSlice({
  name: 'conopPhase1',
  initialState,
  reducers: {
    setConopPhase1Data(state, action) {
      state.conopPhase1Data = action.payload;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const { setConopPhase1Data, setIsRegenerated, setTitle } = actions;

export { name, reducer, setConopPhase1Data, setIsRegenerated, setTitle };

export const selectConopPhase1Data = (state: State) => state[name].conopPhase1Data;
export const selectConopPhase1IsRegenerated = (state: State) => state[name].isRegenerated;
export const selectConopPhase1Title = (state: State) => state[name].title;
